import { memo } from 'react';
import { Box } from '@mui/material';

interface LogoProps {
  variant?: 'full' | 'icon' | 'horizontal';
  size?: 'small' | 'medium' | 'large';
}

const Logo = memo(({ variant = 'horizontal', size = 'medium' }: LogoProps) => {
  const sizes = {
    small: { height: 32, iconSize: 32 },
    medium: { height: 40, iconSize: 40 },
    large: { height: 56, iconSize: 56 },
  };

  const currentSize = sizes[size];

  if (variant === 'icon') {
    return (
      <Box
        component="img"
        src="/logos/icon.png"
        alt="ShiftLabs"
        sx={{
          height: currentSize.iconSize,
          width: currentSize.iconSize,
          objectFit: 'contain',
        }}
      />
    );
  }

  return (
    <Box
      component="img"
      src="/logos/logo-inline-for-black-background.svg"
      alt="ShiftLabs"
      sx={{
        height: currentSize.height,
        objectFit: 'contain',
      }}
    />
  );
});

Logo.displayName = 'Logo';

export default Logo;
